interface getFontValueProps {
	themeFontMap: Record<string, string>
	fontParam: string
	isMobileView: boolean
	callback: (fontValue: string) => unknown
}
export const getFontValue = ({ themeFontMap, fontParam, isMobileView, callback }: getFontValueProps): any => {
	const isValid = fontParam.match(new RegExp(/^font_(.*)/))?.length
	const fontValue = fontParam ? (isValid ? themeFontMap.fontParam : fontParam) : ''
	return isMobileView && fontValue ? callback(fontValue) : fontValue
}
